import { ButtonText } from '@/components/common/Button'
import { InputMenu } from '@/components/common/Input'
import { LinkRoute } from '@/components/common/Link'
import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { useCardRoleLinks } from '@/hooks/useCardRoleLinks'

import styles from './FiltersPanelHeaderDropdown.module.scss'

export const FiltersPanelHeaderDropdown = () => {
  const { page } = usePage()
  const rec = page?.featured?.rec
  const links = useCardRoleLinks({ mode: 'featured', rec })

  if (!links.length) return null

  const menuOptions = links.flatMap(({ icon, options }) =>
    options.map(({ href, label }) => ({
      label: (
        <LinkRoute href={href}>
          <IconWithLabel iconBefore={icon}>{label}</IconWithLabel>
        </LinkRoute>
      ),
    })),
  )

  return (
    <div className={styles.container}>
      <InputMenu aria-label='More Options' options={menuOptions} width='maxcontent'>
        <ButtonText as='div' size='sm'>
          <Icon name='ellipsis' />
        </ButtonText>
      </InputMenu>
    </div>
  )
}
